import styled from "@emotion/styled";
import { Card } from "./card.type";
import { HeadingWithStep } from "../heading-with-step";
import { breakpoints } from "../../../styles/breakpoints";

const StyledVertical = styled.div`
  background-color: var(--white);
  padding: var(--xx-small);
  
  @media(min-width: calc(${breakpoints.md} + 1px)) {
    max-width: calc(50% - var(--xx-small) / 2);
  }

  @media(max-width: ${breakpoints.md}) {
    max-width: 500px;
  }

  .h3 {
    margin: var(--macro) 0;
  }

  .img-container {
    width: 100%;
    height: 220px;
  }
`;

export const Vertical = ({ title, text, step, children }: Card) => (
  <StyledVertical>
    <div className="graphic">{children}</div>
    <div>
      {step ? (
        <HeadingWithStep
          type="h3"
          step={{ src: step.src, alt: `${step.number}` }}
        >
          {title}
        </HeadingWithStep>
      ) : (
        <h3 className="h3">{title}</h3>
      )}

      <p>{text}</p>
    </div>
  </StyledVertical>
);
